import { parse } from "date-fns";

export const formatDateObject = (
  prop: string | null | undefined,
): Date | null => {
  if (!prop) {
    return null;
  }

  try {
    const datePart = prop.split("T")[0];
    const parsedDate = parse(datePart, "dd.MM.yyyy", new Date());

    if (isNaN(parsedDate.getTime())) {
      return null;
    }

    return parsedDate;
  } catch (error) {
    console.error("Error formatting date:", error);
    return null;
  }
};
export const formatDateObjectForT = (
  prop: string | null | undefined,
): Date | null => {
  if (!prop) {
    return null;
  }

  try {
    const datePart = prop.split("T")[0];
    const parsedDate = parse(datePart, "yyyy-MM-dd", new Date());

    if (isNaN(parsedDate.getTime())) {
      return null;
    }

    return parsedDate;
  } catch (error) {
    console.error("Error formatting date:", error);
    return null;
  }
};

import { format, isValid } from "date-fns";

import { dateFormatUTC } from "~/pages/ListOfDocuments/helper";

export const formatDate = (prop: string | null | undefined): string => {
  if (!prop) {
    return "";
  }

  try {
    const datePart = prop.split("T")[0];
    const parsedDate = new Date(datePart);

    if (!isValid(parsedDate)) {
      return "";
    }

    return format(parsedDate, "dd.MM.yyyy");
  } catch (error) {
    console.error("Error formatting date:", error);
    return "";
  }
};

export const transformArray = ({ arr, arg, filter }) => {
  const result = [];
  for (const item of arr) {
    const { id, inn, code, name, category, city } = item;

    result.push({ ...item, icons: "" });

    if (item.contracts && Array.isArray(item[arg])) {
      let contractsWithParentData = item[arg];

      if (filter && filter.id) {
        contractsWithParentData = item[arg].filter(
          (contract) => contract.contractNumber === filter.id,
        );
      }

      contractsWithParentData = contractsWithParentData.map((contract) => {
        const {
          contractDate,
          accountStartDate,
          closeDateForIS,
          dealerSignedDate,
          workStartDate,
          ursosSignedDate,
        } = contract;
        return {
          ...contract,
          id: id,
          contractId: contract.id,
          inn: inn,
          code: code,
          name: name,
          category: category,
          city: city,
          icons: "",
          accountStartDate: formatDate(accountStartDate),
          contractDate: formatDate(contractDate),
          closeDateForIS: formatDate(closeDateForIS),
          dealerSignedDate: formatDate(dealerSignedDate),
          workStartDate: formatDate(workStartDate),
          ursosSignedDate: formatDate(ursosSignedDate),
        };
      });
      result.push(...contractsWithParentData);
    }
  }
  return result;
};

export const editContractToForm = (
  dealerObj,
  contractItem,
  requisite,
  confidant,
) => {
  const {
    inn,
    code,
    name,
    category,
    contractNumber,
    contractDate,
    workStartDate,
    accountStartDate,
    GP,
    dealerSignedDate,
    closeDateForIS,
  } = dealerObj;
  return {
    inn: inn ?? "",
    code: code ?? "",
    name: name ?? "",
    category: category ?? "",
    contractNumber: contractNumber ?? "",
    contractDate: formatDateObject(contractDate),
    workStartDate: formatDateObject(workStartDate),
    accountStartDate: formatDateObject(accountStartDate),
    GP: GP ?? "",
    dealerSignedDate: formatDateObject(dealerSignedDate),
    closeDateForIS: formatDateObject(closeDateForIS),
    isHeadCompany:
      "isHeadCompany" in dealerObj
        ? dealerObj.isHeadCompany
          ? "Да"
          : "Нет"
        : "",
    vaz_requisitesId: contractItem.vaz_requisitesId,
    avtovazBank: contractItem.avtovazBank,
    avtovazAccount: {
      label: contractItem.avtovazAccount,
      value: contractItem.vaz_requisitesId,
    },
    startPrintDate: formatDateObjectForT(contractItem.startPrintDate),
    endPrintDate: formatDateObjectForT(contractItem.endPrintDate),
    printFormId: contractItem.printForm,
    confidantId: confidant,
  };
};

export const editContractToServer = (data) => {
  return {
    contracttype: "main",
    contractNumber: data.contractNumber,
    contractDate: dateFormatUTC(data.contractDate),
    dealerSignedDate: data.dealerSignedDate
      ? dateFormatUTC(data.dealerSignedDate)
      : "",
    accountStartDate: dateFormatUTC(data.accountStartDate),
    closeDateForIS: data.closeDateForIS
      ? dateFormatUTC(data.closeDateForIS)
      : "",
    isSignedByDealer: data?.dealerSignedDate ? true : false,
    confidantId: Number(data.confidantId.value),
    workStartDate: data.workStartDate ? dateFormatUTC(data.workStartDate) : "",
    avtovazBank: data.avtovazBank,
    avtovazAccount: data.avtovazAccount?.label ?? data.avtovazAccount,
    vaz_requisitesId: data.vaz_requisitesId,
    printFormId: Number(data.printFormId.value),
    isHeadCompany: data.isHeadCompany === "Да" ? true : false,
    startPrintDate: data.startPrintDate
      ? dateFormatUTC(data.startPrintDate)
      : "",
    endPrintDate: data.endPrintDate ? dateFormatUTC(data.endPrintDate) : "",
  };
};

export const editAdditionalToForm = (data, confidant, dealerObj) => {
  const {
    inn,
    code,
    name,
    category,
    contractNumber,
    contractDate,
    parentContractId,
  } = dealerObj;
  const additionalData = Object.keys(data).reduce((acc, item) => {
    acc[item] = data[item];
    return acc;
  }, {});

  return {
    inn: inn ?? "",
    code: code ?? "",
    name: name ?? "",
    isHeadCompany:
      "isHeadCompany" in dealerObj
        ? dealerObj.isHeadCompany
          ? "Да"
          : "Нет"
        : "",
    category: category ?? "",
    contractNumberParent: "",
    contractDateParent: "",
    parentContractId: parentContractId, //hidden
    contractNumber: contractNumber ?? "",
    contractDate: formatDateObject(contractDate),
    startForPrint: "",
    closeForPrint: "",
    printFormId: "",
    startDateForIS: "",
    closeDateForIS: "",
    dealerSignedDate: "",
    ursosSignedDate: "",
    confidantId: confidant,
    ...additionalData,
  };
};

export const editAdditionalToServer = (data, id) => {
  return {
    dealerId: id,
    confidantId: Number(data.confidantId.value),
    contractType: "additional",
    parentContractId: Number(data.parentContractId),
    contractNumber: data.contractNumber,
    startDateForIS: data.startDateForIS
      ? dateFormatUTC(data.startDateForIS)
      : "",
    closeDateForIS: data.closeDateForIS
      ? dateFormatUTC(data.closeDateForIS)
      : "",
    contractDate: dateFormatUTC(data.contractDate),
    dealerSignedDate: data.dealerSignedDate
      ? dateFormatUTC(data.dealerSignedDate)
      : "",
    ursosSignedDate: data.ursosSignedDate
      ? dateFormatUTC(data.ursosSignedDate)
      : "",
    startForPrint: dateFormatUTC(data.startForPrint),
    closeForPrint: dateFormatUTC(data.closeForPrint),
    printFormId: Number(data.printFormId.value),
  };
};
